import { render, staticRenderFns } from "./OpenIdCallback.vue?vue&type=template&id=a91258da"
import script from "./OpenIdCallback.vue?vue&type=script&lang=js"
export * from "./OpenIdCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports